import { Form } from 'antd';
import styles from './search.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';

const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const { setSearchValue } = props;
  const onFinish = (values) => {
    setSearchValue(values.fieldName);
  };

  return (
    <Form
      form={form}
      name="filed-search"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      <div className={styles.input_contain}>
        {/* 字段名称 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="字段筛选"
          placeVal="请输入字段名称"
          name="fieldName"
          allowClear={true}
          // icon={}
        />
      </div>
      <div className={styles.btn_contain}>
        <ButtonML size="large" value="筛选" htmlType="submit" />
      </div>
    </Form>
  );
};

export default SearchGroup;
